export const getFileNameFromPath = (path: string, uuid: string) => {
  const pattern = new RegExp(`${uuid}_(.+)$`);
  const match = pattern.exec(path);

  if (match) {
    return match[1];
  }

  const parts = path.split('/');
  return parts.length ? parts[parts.length - 1] : null;
};
